import React, { useState } from "react";
import { MainLayout } from "@/components/layouts/MainLayout";
import PostForm from "@/components/community/PostForm";
import { IPost } from "@/lib/community";
import PostModal from "@/components/community/PostModal";
import PostsList from "@/components/community/PostsList";
import { usePosts } from "@/hooks/usePosts";
import { LeaderBoardCard } from "@/components/community/LeaderBoardCard";
import { IntroductoryCard } from "@/components/community/IntroductoryCard";
import { useNavigate } from "react-router";
import { MixpanelActions } from "@/integrations/mixpanel/mixpanel";

export default function Community() {
  const { handleAddTopPost, handleUpdatePost } = usePosts();
  const [selectedPost, setSelectedPost] = useState<IPost | null>(null);

  const navigate = useNavigate();

  const handlePostClick = (post: IPost) => {
    MixpanelActions.openPost(post);
    if (window.innerWidth < 768) {
      navigate(`/post/${post.id}`);
    } else {
      setSelectedPost(post);
    }
  };

  return (
    <MainLayout className="">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 md:col-span-8 md:row-start-1">
          <PostForm onPostAdd={handleAddTopPost} />
          <PostsList onPostClick={handlePostClick} />
          {selectedPost && (
            <PostModal
              post={selectedPost}
              onUpdate={(post) => {
                handleUpdatePost(post);
                setSelectedPost(post);
              }}
              onClose={() => setSelectedPost(null)}
              setSelectedPostToNull={() => setSelectedPost(null)}
            />
          )}
        </div>
        <div className="row-start-1 col-span-12 md:col-span-4 space-y-2">
          <IntroductoryCard />
          <LeaderBoardCard />
        </div>
      </div>
    </MainLayout>
  );
}
